import getProtocol from './getProtocol.mjs';

const getUrlFromRequest = (request) => `${getProtocol(request)
}://${request.get('host')}${request.originalUrl}`;

export default getUrlFromRequest;
